/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.74728 5H19.2324C19.5821 5 19.9317 5.2 20.1315 5.5L21.9297 8.25C22.1295 8.55 21.8797 9 21.4801 9H2.49958C2.09999 9 1.85025 8.55 2.09999 8.25L3.89815 5.45C4.048 5.2 4.39764 5 4.74728 5ZM3.4986 18V9.99999H20.4812V18C20.4812 18.55 20.0317 19 19.4822 19H18.4832V13.5C18.4832 13.2 18.2835 13 17.9838 13H13.9879C13.6882 13 13.4884 13.2 13.4884 13.5V19H4.49757C3.94814 19 3.4986 18.55 3.4986 18ZM5.49655 16H11.4904V13H5.49655V16Z",
  fill: "currentColor"
})), 'Store');